import { TaskInstance } from "@/lib/api/checklist";
import { SendDestinationEnvelopeFormCore } from "@/section/destinationPackets/components/SendDestinationEnvelopeFormCore";

interface SendDestinationEnvelopeFormProps {
  taskInstance: TaskInstance;
  onSuccess?: () => void;
}

export function SendDestinationEnvelopeForm({ taskInstance, onSuccess }: SendDestinationEnvelopeFormProps) {
  // Get trigger meta data for prefilling
  const triggerMetaData = taskInstance.template_instance?.trigger_meta_data || {};
  
  // Extract customer information from trigger meta data
  // Note: customer_id might not be in trigger_meta_data, but customer_name and email can help users find the customer
  const customerName = triggerMetaData.customer_name as string | undefined;
  const customerEmail = triggerMetaData.email as string | undefined;

  return (
    <SendDestinationEnvelopeFormCore
      initialCustomerId={undefined}
      initialPacketId={null}
      onSuccess={onSuccess}
      onCancel={undefined}
      isModal={true}
    />
  );
}

